export default __webpack_public_path__ + "static/media/Metropolis-Regular.67a1988d.otf";